import React from "react"

interface Props {
    title?: string
    waitTime?: number
    onNext: () => void
}

/**
 * This page is just to inform user that the module is over.
 * It will move to the next after the wait time...
 */
export default function ModuleOverPage(props: Props) {
    let {title, waitTime=3000, onNext} = props

    setTimeout(() => {
       onNext()
    }, waitTime)

    return (
        <>
            <div className="page-msg-fullscreen page--ptModule">
                <div className="container w-100 mx-auto">
                    <div className="row justify-content-center text-center">
                        <div className="col-12" style={{ maxWidth: '940px' }}>
                            <h1 className="page-title w-100 d-block mb-4">
                                {title} Is Over
                            </h1>
                            <h5 className="mb-4">All your work has been saved.</h5>
                            <h5 className="mb-4">You'll move on automatically in just a moment.</h5>
                            <h5 className="mb-4">Do not refresh this page or quit the app.</h5>
                            <img width="60" height="60" src="/assets/images/filament-loading-transparent-bkgd.gif" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
